export const LOGIN_PATH='/auth/login'
export const CAMPAIGNS_PATH='/retail/all-campaigns'
export const FIRST_TIME_LOGIN_PATH='/auth/new-password'
export const NEW_CAMPAIGN_PATH='/retail/new-campaign';
export const EDIT_CAMPAIGN_PATH='/retail/edit-campaign';
export const PICK_SERVER_PATH='/retail/servers'
export const LAZADA_REDIRECT_URI = '/lazada/callback'

export const ADMIN_NAME=process.env.REACT_APP_ENV === 'development' ? 'admin_testing' : 'admin'